import { createContext, useContext } from 'react';

const noop = () => {};

export const NavSidebarContext = createContext({
  isCollapsed: false,
  toggleCollapsed: noop,
  requestCollapse: noop,
  releaseCollapse: noop,
});

export const useNavSidebar = () => useContext(NavSidebarContext);
